export default class ThumbExistingBucket {
  constructor(item) {
    if (item) {
      this.thumbBucketProfileId = item.thumbBucketProfileId;
      this.bucketStyle = item.bucketStyle;
      this.width = item.width;
      this.capacityUnits = item.capacityUnits;
      this.capacityUnitsName = item.capacityUnitsName;
      this.minimumCapacity = item.minimumCapacity;
      this.maximumCapacity = item.maximumCapacity;
      this.overallTipRadius = item.overallTipRadius;
      this.brand = item.brand;
      this.amiSerialNumber = item.amiSerialNumber;
      this.otherBrandName = item.otherBrandName;
      this.toothCount = item.toothCount;
      this.toothStyle = item.toothStyle;
      this.photos = item.photos;
      return;
    }
    this.thumbBucketProfileId = null;
    this.bucketStyle = null;
    this.width = 0;
    this.capacityUnits = null;
    this.capacityUnitsName = '';
    this.minimumCapacity = 0;
    this.maximumCapacity = 0;
    this.overallTipRadius = 0;
    this.brand = null;
    this.amiSerialNumber = '';
    this.otherBrandName = '';
    this.toothCount = null;
    this.toothStyle = null;
    this.photos = [];
  }

  getBucketForDisplay() {
    const desc = '';

    if (!this.minimumCapacity && !this.maximumCapacity) return desc + 'Any';

    if (!this.minimumCapacity)
      return (
        desc +
        'Up to ' +
        this.maximumCapacity.toString() +
        ' ' +
        this.capacityUnitsName
      );

    if (!this.maximumCapacity)
      return (
        desc +
        this.minimumCapacity.toString() +
        ' ' +
        this.capacityUnitsName +
        ' and up'
      );

    return (
      desc +
      this.minimumCapacity.toString() +
      ' ' +
      this.capacityUnitsName +
      ' to ' +
      this.maximumCapacity.toString() +
      ' ' +
      this.capacityUnitsName
    );
  }
}
